import { render, staticRenderFns } from "./companyDocumentSetups.vue?vue&type=template&id=a44dd6e6"
import script from "./companyDocumentSetups.vue?vue&type=script&lang=js"
export * from "./companyDocumentSetups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports